export default __webpack_public_path__ + "static/media/foot-left-side.580a98eb.png";